import {Component, Input} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCard, MatCardContent, MatCardHeader, MatCardModule, MatCardTitle} from '@angular/material/card';
import {MatChipsModule} from '@angular/material/chips';
import {MatIcon} from '@angular/material/icon';
import {Router, RouterLink} from '@angular/router';
import {pdcRoutes, pdeRoutes, ROUTE_BASE} from '@app/routing/routes';
import {type TileInfo} from '@models/tile-info';
import {FlexModule} from '@ngbracket/ngx-layout';
import {OrgService} from '@services/organization/org.service';
import {EventMetadataPipe} from '@shared/pipes/format-metadata/event-metadata.pipe';

@Component({
  selector: 'app-generic-tile',
  imports: [
    MatCard,
    MatCardHeader,
    MatCardContent,
    MatCardTitle,
    MatCardModule,
    MatIcon,
    MatButtonModule,
    MatChipsModule,
    FlexModule,
    RouterLink,
    EventMetadataPipe,
  ],
  templateUrl: './generic-tile.component.html',
  styleUrl: './generic-tile.component.scss',
})
export class GenericTileComponent {
  @Input() TileInfo: TileInfo;

  constructor(
    private readonly router: Router,
    private readonly orgService: OrgService,
  ) {}

  goToLink(tile: TileInfo) {
    if (tile) {
      const targetUrl = this.getNavigationUrl(tile); // Get the URL based on TileInfo
      this.router.navigate([targetUrl]);
    }
  }

  onKeyDown(event: KeyboardEvent, tile: TileInfo) {
    if (event.key === 'Enter') {
      this.goToLink(tile);
    }
  }

  getNavigationUrl(tile: TileInfo): any[] {
    if (tile.type === 'Resource' || tile.type === 'Event') {
      return ['/', ROUTE_BASE.RE, 'view', tile.id];
    }

    const type = tile.type.toLowerCase();
    const currentUrl = this.router.url;

    if (type === 'dataset') {
      if (currentUrl.includes(ROUTE_BASE.PDE)) {
        return pdeRoutes.datasetView(tile.id);
      }

      if (currentUrl.includes(ROUTE_BASE.PDC)) {
        return pdcRoutes.datasetView(tile.id);
      }
    }

    if (type === 'project') {
      if (currentUrl.includes(ROUTE_BASE.PDE)) {
        return pdeRoutes.projectView(tile.id);
      }

      if (currentUrl.includes(ROUTE_BASE.PDC)) {
        return pdcRoutes.projectView(tile.id);
      }
    }

    return ['/'];
  }

  /**
   * Returns an organization's full name based on the "organization" value from TileInfo
   * @param tile
   */
  getOrganizationFullName(tile: TileInfo): string {
    return this.orgService.getOrganizationFullName(tile.organization);
  }

  /**
   * Returns a logo image URL (string) based on the "organization" value from TileInfo
   * @param tile
   */
  getOrganizationLogo(tile: TileInfo): string {
    return this.orgService.getRecordTileLogo(tile.organization);
  }

  getIconForType(tile: TileInfo): string {
    const sanitizedType = tile.type.toLowerCase();

    if (sanitizedType === 'resource') {
      return 'ads_click';
    } else if (sanitizedType === 'project') {
      return 'auto_awesome_mosaic';
    }

    return sanitizedType;
  }
}
